import { Stack, styled } from '@mui/material';

export const StackStyled = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(1),
  flexWrap: 'wrap',
}));
